"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * @param $translateProvider
 * @param translateLoaderModuleProvider
 * @param localizationServiceProvider
 * @param configuration
 * @ngdoc module
 * @module i18n
 * @area lib
 * @name translate
 * @description
 *
 *   This controller is the i18n module
 */
angular.module('i18n', ['ngSanitize', 'mgcrea.ngStrap.select', 'pascalprecht.translate', 'configuration', 'i18n.localization', 'i18n.translate', 'i18n.directives']).config(['$translateProvider', 'translateLoaderModuleProvider', 'localizationServiceProvider', 'configuration', function ($translateProvider, translateLoaderModuleProvider, localizationServiceProvider, configuration) {
  // Get the locale
  var locale = localizationServiceProvider.getActiveLocale();

  // Configuration of angular-translate for the entire application.
  if (configuration.i18n.pattern) {
    $translateProvider.useLoader('translateLoaderModule', {
      templatesUrl: configuration.i18n.pattern,
      teleservice: configuration.i18n.teleservice
    });
  }

  // Configuration of the culture of kendo if the var exist
  if (Object.prototype.hasOwnProperty.call(window, 'kendo')) {
    kendo.culture(locale);
  }
  $translateProvider.use(locale);
}]);
angular.module('i18n.directives', ['i18n.directives.language-selection']);

// eslint-disable-next-line jsdoc/require-returns
/**
 * @ngdoc module
 * @module i18n
 * @area lib
 * @name i18n.languageSelection
 * @description
 */
angular.module('i18n.directives.language-selection', ['i18n.localization.service']).directive('languageSelection', [function () {
  return {
    restrict: 'A',
    replace: true,
    transclude: false,
    templateUrl: 'language-selection.tpl.html',
    scope: {
      languages: '=',
      placeholder: '@'
    },
    controller: ['$scope', '$window', 'localizationService', function ($scope, $window, localizationService) {
      // Initialize language
      $scope.selectedLanguage = localizationService.getActiveLocale();
      localizationService.initializeLanguage($scope.selectedLanguage);

      // Change the language of the application
      $scope.changeLanguage = function (selectedLanguage) {
        localizationService.changeLanguage(selectedLanguage);
      };
    }]
  };
}]);

/**
 * @param $templateCache
 * @ngdoc module
 * @module i18n
 * @area lib
 * @name i18n.templateCache
 * @description
 *
 *   This controller is the i18n templateCache
 */
angular.module('i18n.directives.language-selection').run(['$templateCache', function ($templateCache) {
  $templateCache.put('language-selection.tpl.html', '<button type="button" class="btn btn-sm btn-primary" ng-change="changeLanguage(selectedLanguage)" placeholder="{{placeholder}}"' + 'ng-model="selectedLanguage" data-html="1"' + 'ng-options="language.value as language.label for language in languages" bs-select>' + '<span class="caret"></span>' + '</button>');
}]);

/**
 * @param tmhDynamicLocaleProvider
 * @param configuration
 * @ngdoc module
 * @module i18n
 * @area lib
 * @name localization.tmhDynamicLocaleProvider
 * @description
 *
 *   This controller is the i18n tmhDynamicLocaleProvider
 */
angular.module('i18n.localization', ['tmh.dynamicLocale', 'configuration', 'i18n.localization.service']).config(['tmhDynamicLocaleProvider', 'configuration', function (tmhDynamicLocaleProvider, configuration) {
  tmhDynamicLocaleProvider.localeLocationPattern("".concat(configuration.i18n['angular-i18n'].path, "/angular-locale_{{locale}}.js"));
}]);

/**
 * @param configuration
 * @ngdoc module
 * @module i18n
 * @area lib
 * @name localization.localizationService
 * @description
 *
 *   This controller is the i18n localizationService service
 */
angular.module('i18n.localization.service', ['configuration', 'tmh.dynamicLocale']).provider('localizationService', ['configuration', function (configuration) {
  var getLocaleBrowser = function getLocaleBrowser() {
    var nav = window.navigator;
    var locale = (nav.language || nav.browserLanguage || nav.systemLanguage || nav.userLanguage || '').split('-').join('_');
    if (locale.length > 2) {
      locale = locale.substring(0, 2);
    }
    return locale.toLowerCase();
  };
  var getLocaleInCache = function getLocaleInCache() {
    return window.localStorage.getItem('i18n.locale');
  };
  this.getActiveLocale = function () {
    return getLocaleInCache() || configuration.i18n.defaultLocale || getLocaleBrowser();
  };
  this.$get = ['$q', 'tmhDynamicLocale', function ($q, tmhDynamicLocale) {
    return {
      getActiveLocale: function getActiveLocale() {
        return getLocaleInCache() || getLocaleBrowser();
      },
      initializeLanguage: function initializeLanguage(language) {
        var deferred = $q.defer();
        tmhDynamicLocale.set(language.toLowerCase()).then(function (results) {
          window.localStorage.setItem('i18n.locale', language);
          deferred.resolve(results);
        });
        return deferred.promise;
      },
      changeLanguage: function changeLanguage(selectedLanguage) {
        window.localStorage.setItem('i18n.locale', selectedLanguage);
        window.location.reload();
      }
    };
  }];
}]);

/**
 * @ngdoc module
 * @module i18n
 * @area lib
 * @name translate
 * @description
 *
 *   This controller is the i18n translate module
 */
angular.module('i18n.translate', ['i18n.translate.translateLoaderModule', 'i18n.translate.translateLoaderDynamic']);

/**
 * @ngdoc module
 * @module i18n
 * @area lib
 * @name translate.translateLoaderModule
 * @description
 *
 *   This controller is the i18n translateLoaderModule
 */
angular.module('i18n.translate.translateLoaderModule', []).provider('translateLoaderModule', [function () {
  /**
   *
   * @param {string} str
   * @returns {boolean}
   */
  function isStringValid(str) {
    return angular.isString(str) && str !== '';
  }

  /**
   * Function who replace key in url template with values from context
   * @param templateUrl Url template
   * @param context Context
   * @returns {*}
   */
  function parseUrlWithContext(templateUrl, context) {
    // eslint-disable-next-line no-restricted-syntax
    for (var property in context) {
      if (Object.prototype.hasOwnProperty.call(context, property)) {
        var regExp = new RegExp("{".concat(property, "}"), 'g');
        // eslint-disable-next-line no-param-reassign
        templateUrl = templateUrl.replace(regExp, context[property]);
      }
    }
    return templateUrl;
  }

  /**
   * Definition of a module
   * @param {Module} name Name of the module. Constructor
   */
  function Module(name) {
    this.name = name;
    this.translations = {};
  }
  Module.prototype.parseUrl = function (templateUrl, lang, context) {
    // eslint-disable-next-line no-param-reassign
    templateUrl = templateUrl.replace(/\{module\}/g, this.name).replace(/\{lang\}/g, lang);
    // eslint-disable-next-line no-param-reassign
    templateUrl = parseUrlWithContext(templateUrl, context);
    return templateUrl;
  };
  Module.prototype.getTranslations = function (lang, $q, $http, templatesUrl, context) {
    var deferred = $q.defer();
    if (angular.isArray(templatesUrl)) {
      if (!this.translations[lang]) {
        var that = this;
        var promises = [];
        templatesUrl.forEach(function (templateUrl) {
          // eslint-disable-next-line no-param-reassign
          templateUrl = that.parseUrl(templateUrl, lang, context);
          if (templateUrl.indexOf('{') === -1) {
            promises.push($http({
              method: 'GET',
              url: templateUrl
            })["catch"](function () {
              return {};
            }));
          }
        });
        $q.all(promises).then(function (results) {
          var translations = {};
          results.forEach(function (result) {
            $.extend(true, translations, result.data);
          });
          that.translations[lang] = translations;
          deferred.resolve(translations);
        }, function () {
          deferred.reject(that.name);
        });
      } else {
        deferred.resolve(this.translations[lang]);
      }
    }
    return deferred.promise;
  };

  // List of modules loaded in the application
  var modules = {};

  /**
   * Verify is the module has been loaded at the application level
   * @param {string} name Name of the module
   * @returns {boolean} Indicates whether the module has been loaded
   */
  function hasModule(name) {
    return Object.prototype.hasOwnProperty.call(modules, name);
  }

  /**
   * Add the module to the list
   * @param {string} name Name of the module
   */
  this.addModule = function (name) {
    if (!isStringValid(name)) {
      throw new TypeError("Couldn't add module, module name has to be a string!");
    }
    if (!hasModule(name)) {
      modules[name] = new Module(name);
    }
    modules[name].isActive = true;
  };

  /**
   * Delete the module of the list
   * @param  {string} name Name of the module
   */
  this.deleteModule = function (name) {
    if (!isStringValid(name)) {
      throw new TypeError("Couldn't delete module, first arg has to be string.");
    }
    if (hasModule(name)) {
      modules[name].isActive = false;
    }
  };
  var teleservices = {};

  /**
   *
   * @param {string} lang
   * @param {object} $q
   * @param {object} $http
   * @param {object} teleservice
   * @param {string} workflow
   * @param {string} templatesUrl
   * @param {object} context
   * @returns {Promise<object>}
   */
  function getTeleserviceTranslations(lang, $q, $http, teleservice, workflow, templatesUrl, context) {
    var deferred = $q.defer();
    if (teleservices[teleservice] && teleservices[teleservice][lang]) {
      deferred.resolve(teleservices[teleservice][lang]);
    } else {
      var promises = [];
      templatesUrl.forEach(function (templateUrl) {
        // eslint-disable-next-line no-param-reassign
        templateUrl = parseUrlWithContext(templateUrl, context);
        // eslint-disable-next-line no-param-reassign
        templateUrl = templateUrl.replace(/\{workflow\}/g, workflow).replace(/\{teleservice\}/g, teleservice).replace(/\{lang\}/g, lang);
        if (templateUrl.indexOf('{') === -1) {
          promises.push($http({
            method: 'GET',
            url: templateUrl
          })["catch"](function () {
            return {};
          }));
        }
      });
      $q.all(promises).then(function (results) {
        var translations = {};
        results.forEach(function (result) {
          $.extend(true, translations, result.data);
        });
        teleservices[teleservice] = teleservices[teleservice] || {};
        teleservices[teleservice][lang] = translations;
        deferred.resolve(translations);
      }, function () {
        deferred.reject(teleservice);
      });
    }
    return deferred.promise;
  }
  this.$get = ['$q', '$http', function ($q, $http) {
    var currentContext = {};
    var service = function service(options) {
      var deferred = $q.defer();
      var loaders = [];
      // eslint-disable-next-line no-restricted-syntax
      for (var module in modules) {
        if (hasModule(module) && modules[module].isActive) {
          // if loaders is filled, it means that we're refreshing (i.e. adding a module), so we only refresh modules
          var templatesUrl = loaders.length === 0 ? options.templatesUrl : options.templatesUrl.filter(function (templateUrl) {
            return templateUrl.includes('{module}');
          });
          loaders.push(modules[module].getTranslations(options.key, $q, $http, templatesUrl, currentContext));
        }
      }

      // Also fetch translations for the current teleservice if defined
      if (options.teleservice && options.teleservice.id && options.teleservice.workflow && options.teleservice.pattern) {
        loaders.push(getTeleserviceTranslations(options.key, $q, $http, options.teleservice.id, options.teleservice.workflow, options.teleservice.pattern, currentContext));
      }

      // Also fetch translations for additional translations routes if defined (should not have a module parameter)
      if (Array.isArray(options.additionalTranslations)) {
        var _iterator = _createForOfIteratorHelper(options.additionalTranslations),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var additionalTranslation = _step.value;
            var url = Module.prototype.parseUrl(additionalTranslation, options.key, currentContext);
            if (url.indexOf('{') === -1) {
              loaders.push($http({
                method: 'GET',
                url: url
              }).then(function (response) {
                return response.data;
              })["catch"](function () {
                return {};
              }));
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (loaders.length) {
        $q.all(loaders).then(function (translations) {
          var translationMap = {};
          for (var i = 0; i < translations.length; i += 1) {
            $.extend(true, translationMap, translations[i]);
          }
          deferred.resolve(translationMap);
        }, function () {
          deferred.reject(options.key);
        });
      } else {
        deferred.resolve({});
      }
      return deferred.promise;
    };
    service.updateContext = function (context) {
      currentContext = context;
    };
    return service;
  }];
}]);

/**
 * @ngdoc module
 * @module i18n
 * @area lib
 * @name translate.translateLoaderDynamic
 * @description
 *
 *   This controller is the i18n translateLoaderDynamic
 *
 *   It should replace the translateLoaderModule which was charge with some logic required when merging resources
 *   from client side component.
 *   This one fetches already merged resources from a service, but it has the capacity to load translations at runtime.
 *   This is useful in multi-tenant applications
 */
angular.module('i18n.translate.translateLoaderDynamic', []).provider('translateLoaderDynamic', [function () {
  // angular-translate will use this function to fetch translations when refreshed
  this.$get = ['$q', '$http', '$log', function ($q, $http, $log) {
    var currentContext = {};

    // simili mustache
    /**
     *
     * @param {string} pattern
     * @returns {string}
     */
    function applyContextToPattern(pattern) {
      Object.keys(currentContext).forEach(function (contextKey) {
        // eslint-disable-next-line no-param-reassign
        pattern = pattern.replace(new RegExp("{{".concat(contextKey, "}}"), 'g'), currentContext[contextKey]);
      });
      if (pattern.indexOf('{{') !== -1) {
        $log.debug('i18n.translate.translateLoaderService pattern not fully resolved (missing var)', pattern);
        return null;
      }
      return pattern;
    }

    // loader is a function as expected by angular translate
    var loader = function loader(options) {
      if (!options.patterns) {
        $log.error('i18n.translate.translateLoaderService options require a key "patterns"');
        return;
      }
      currentContext.locale = options.key;
      var urls = options.patterns.map(applyContextToPattern);
      urls = urls.filter(function (url) {
        return !!url;
      });
      var promises = [];
      urls.forEach(function (url) {
        promises.push($http.get(url).then(function (response) {
          if (response.status !== 200) {
            throw new Error("i18n.translate.translateLoaderService Failed to fetch ".concat(url, " with error ").concat(response.statusCode, " - ").concat(response.data));
          }
          return response.data;
        }));
      });
      var translations = {};
      // eslint-disable-next-line consistent-return
      return $q.all(promises).then(function (responses) {
        responses.forEach(function (response) {
          $.extend(true, translations, response);
        });
        return translations;
      });
    };

    // but loader is also an object with another function as attribute
    loader.updateContext = function (context) {
      $log.debug('i18n.translate.translateLoaderService update context', context);
      currentContext = context;
    };
    return loader;
  }];
}]);